/**
 *
 * Header
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import StarIcon from '@material-ui/icons/Star';
import TranslateIcon from '@material-ui/icons/Translate';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import lodashMap from 'lodash/map';
import { intlShape, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Tooltip } from '@material-ui/core';
import AppPreloader from 'components/AppPreloader';
import withWindowSize from 'utils/withWindowSize';
import FavoriteFolderBtnsNoticePopup from 'components/Popups/FavoriteFolderBtnsNoticePopup';
import ReactGA from 'googleAnalytics';
import { SmartLink } from '../SmartLink';
import MainMenu from './MainMenu';
import TestTranslationMenu from './TestTranslationMenu';
import messages from './messages';
import strengthLogo from '../../img/strength-logo.svg';
import postureLogo from '../../img/posture-logo.svg';
import yogaLogo from '../../img/yoga-logo.svg';
import anatomyLogo from '../../img/anatomy-logo.svg';
import { makeSelectGlobal } from '../../containers/App/selectors';
import { makeSelectLocale } from '../../containers/LanguageProvider/selectors';
import styles from './styles';
import * as authActions from '../../containers/AuthReg/actions';
import * as AppActions from '../../containers/App/actions';
import * as languageActions from '../../containers/LanguageProvider/actions';
import axios from '../../utils/axiosConfig';
import { CURRENT_VERTICAL } from '../../verticalConfigs';
import { PRICING_PAGE } from '../../utils/constants';
import * as authRegMessages from '../AuthRegComponent/messages';
import favoriteFolderBtnsMessages from '../FavoriteFolderBtns/messages';
import { mmIcons } from '../../mmIcons';
import * as constants from './constants';
import * as helpers from './helpers';
import adjust from '../../adjust';
import { setEntryPoint, setSubscriber, setMode, setPlan, mixpanelStorage } from '../../localStorage';
import mixpanel from '../../mixpanel';
import * as azActions from '../../containers/Azlist/actions';

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    // const vertical = CURRENT_VERTICAL || 'strength';
    this.state = {
      // vertical: this.props.intl.formatMessage(messages[vertical]),
      anchorEl: null,
      verticalEl: null,
      languagesFlag: false,
      linkTo: '/login',
      openDialog: false,
      isOpenEasterEgg: false,
      passArr: [],
      passArrSecond: [],
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleToggleEasterEgg);
    document.addEventListener('keydown', this.handleToggleEasterEggSecond);
    // eslint-disable-next-line no-restricted-globals
    const { search } = location;
    const searchMatching = search.match(/(firebase|mixpanel)=(on|off)/);
    if (searchMatching && searchMatching.length > 1) {
      sessionStorage.setItem(searchMatching[1], searchMatching[2]);
      // eslint-disable-next-line no-restricted-globals
      location.href = location.pathname;
    }
    ReactGA.sendTheoryViewTime();
    mixpanel.sendTheoryViewTime();
    mixpanel.sendMuscleOriginViewTime();
    mixpanel.sendExerciseViewTime();
    mixpanel.firstAppOpen();
    this.handleSetUpgradeButtonText();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { global } = nextProps;
    if (global.user.data) {
      if (localStorage.getItem('language') && localStorage.getItem('language') !== global.user.data.language_id) {
        axios.setLanguage(global.user.data.language_id);
        this.props.changeLocale(global.user.data.language_id);
      }
      // eslint-disable-next-line no-restricted-globals
      if (location.search.match(/login/)) {
        // eslint-disable-next-line no-restricted-globals
        document.location.href = location.pathname;
      }
      setSubscriber(global?.user?.data?.is_paid);
      this.handleSetUpgradeButtonText();

      if (global?.user?.data?.is_paid && global?.user?.data.vertical_id === 'strength') {
        const typeForGa = global?.user?.data?.paid_status?.billing?.toLowerCase().replace(/3years/, '3Year');
        setPlan(typeForGa);
        setMode(global?.user?.data.paid_status.type === 'indi' ? 'individual' : global?.user?.data.paid_status.type);
      }
      // eslint-disable-next-line no-restricted-globals
      if (location.search.match(/checkpayment/)) {
        if (global.user.data.is_paid) {
          // eslint-disable-next-line no-restricted-globals
          document.location.href = location.pathname;
        }
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleToggleEasterEgg);
    document.removeEventListener('keydown', this.handleToggleEasterEggSecond);
  }

  handleSetUpgradeButtonText = () => {
    const {
      global: { firebaseDB },
    } = this.props;
    if (firebaseDB?.data?.pricing?.general?.webapp_header_button) {
      mixpanelStorage.setItem('iapButtonText', firebaseDB?.data?.pricing?.general.webapp_header_button);
    }
  };

  handleToggleEasterEgg = ({ key }) => {
    if (this.state.passArr.length < constants.LENGTHOFKEYS) {
      this.setState(state => ({ passArr: [...state.passArr, key] }));

      const isRequired =
        this.state.passArr.length === constants.LENGTHOFKEYS && this.state.passArr.join('') === constants.SETOFKEYS;
      if (isRequired) {
        this.setState(state => ({ isOpenEasterEgg: !state.isOpenEasterEgg, passArr: [] }));
      }
    }

    if (this.state.passArr.length === constants.LENGTHOFKEYS) {
      const currPassArr = [...this.state.passArr];
      currPassArr.shift();
      this.setState({ passArr: [...currPassArr, key] });

      if (currPassArr.join('') + key === constants.SETOFKEYS) {
        this.setState(state => ({ isOpenEasterEgg: !state.isOpenEasterEgg, passArr: [] }));
      }
    }
  };

  trackPricingPage = upgradeButtonMessage => () => {
    adjust.trackPricing('BannerPopupHeader');
    ReactGA.event('pricingBanner_click', { buttonText: upgradeButtonMessage });
    setEntryPoint('pricingBanner');
    mixpanelStorage.setItem('entryPoint', 'Pricing Banner');
  };

  handleToggleEasterEggSecond = ({ key }) => {
    if (this.state.passArrSecond.length < constants.LENGTHOFKEYSSECOND) {
      this.setState(state => ({ passArrSecond: [...state.passArrSecond, key] }));

      const isRequired =
        this.state.passArrSecond.length === constants.LENGTHOFKEYSSECOND &&
        this.state.passArrSecond.join('') === constants.SETOFKEYSSECOND;
      if (isRequired) {
        this.setState(state => ({ isOpenEasterEgg: !state.isOpenEasterEgg, passArrSecond: [] }));
      }
    }

    if (this.state.passArrSecond.length === constants.LENGTHOFKEYSSECOND) {
      const currpassArrSecond = [...this.state.passArrSecond];
      currpassArrSecond.shift();
      this.setState({ passArrSecond: [...currpassArrSecond, key] });

      if (currpassArrSecond.join('') + key === constants.SETOFKEYSSECOND) {
        this.setState(state => ({ isOpenEasterEgg: !state.isOpenEasterEgg, passArrSecond: [] }));
      }
    }
  };

  handleMenu = event => this.setState({ anchorEl: event.currentTarget });

  handleClose = () => this.setState({ anchorEl: null, languagesFlag: false });

  handleVertical = event => this.setState({ verticalEl: event.currentTarget });

  handleCloseVertical = () => this.setState({ verticalEl: null });

  handleLogout = () => {
    const firstAppOpen = mixpanelStorage.getCleanItem('firstAppOpen');

    this.props.dispatch({ type: 'LOG_OUT' });
    axios.post('users/logout');
    this.props.history.push('/login');
    localStorage.clear();
    localStorage.setItem('mixpanel_firstAppOpen', firstAppOpen);
    axios.removeXApiKey();
  };

  handleShowLanguages = () => this.setState(state => ({ languagesFlag: !state.languagesFlag }));

  fetchCheckLoginLink = () => {
    if (!this.props.global.user.data) return { link: '/login' };
    return { func: this.handleLogout };
  };

  handleSelectLanguage = language => {
    const { localLanguage, changeLocale, userChangeLocale, getFirebaseUpdateLanguage } = this.props;
    if (language !== localLanguage) {
      ReactGA.event('1oldlanguage_select', { language_id: language });
      axios.setLanguage(language);
      userChangeLocale(language);
      changeLocale(language);
      getFirebaseUpdateLanguage();

      this.props.getAZActionAction(this.props.dispatch);
    }
  };

  handleDialog = () =>
    this.setState(prev => ({
      openDialog: !prev.openDialog,
    }));

  correctLogo = () => {
    let logo = strengthLogo;
    if (CURRENT_VERTICAL === 'posture') logo = postureLogo;
    else if (CURRENT_VERTICAL === 'yoga') logo = yogaLogo;
    else if (CURRENT_VERTICAL === 'anatomy') logo = anatomyLogo;
    return logo;
  };

  render() {
    const {
      classes,
      global,
      global: {
        vertical,
        firebaseDB,
        user: { data: user, loading: userDataLoading },
      },
      intl: { formatMessage },
      router: { location },
      windowSize: { type: deviceType },
    } = this.props;
    const pricing = firebaseDB?.data?.pricing;
    const { anchorEl, verticalEl, languagesFlag, linkTo, openDialog, isOpenEasterEgg } = this.state;
    const open = Boolean(anchorEl);
    const isBrowserAllowed = helpers.inspectBrowser();

    const menuItems = [
      { label: formatMessage(messages.myProfile), link: '/profile', icon: <AccountCircle /> },
      {
        label: formatMessage(messages.myCollection),
        link: '/my-folders',
        icon: <StarIcon />,
        private: true,
        func: this.handleDialog,
      },
      {
        label: global.user.data ? formatMessage(messages.logout) : formatMessage(messages.login),
        ...this.fetchCheckLoginLink(),
        icon: <ExitToAppIcon />,
      },
    ];
    const langObj = {
      label: formatMessage(messages.languages),
      func: this.handleShowLanguages,
      icon: <TranslateIcon />,
      items: ['en', 'es', 'pt', 'ru', 'ko', 'de'],
    };

    menuItems.splice(menuItems.length - 1, 0, langObj);
    const openVertical = Boolean(verticalEl);
    const isLock = ((user && !user.is_paid) || !user) && location.pathname !== '/login';
    const isDailyYoga = location.pathname === '/registration/dailyyoga';
    const isSaleLink = isLock && !isDailyYoga && isBrowserAllowed;
    const userName = !userDataLoading && user ? user.name : formatMessage(messages.guest);
    const infoMsg = (
      <>
        <div className={classes.infoMsgBlock}>
          <p>{formatMessage(messages.title, { name: userName })}</p>
          <p>{formatMessage(messages.description1)}</p>
          <p>{formatMessage(messages.description2)}</p>
          <p>{formatMessage(messages.description3)}</p>
        </div>
        <div className={classes.infoMsgBlock}>
          <p>{formatMessage(messages.description4)}</p>
          <p>{formatMessage(messages.description5)}</p>
          <p>{formatMessage(messages.description6)}</p>
        </div>
        <div className={classes.infoMsgBlock}>
          <p>{formatMessage(messages.description10)}</p>
          <p>{formatMessage(messages.description11)}</p>
        </div>
      </>
    );

    const isFullSizeDevice = deviceType === 'full';
    const isTabletDevice = deviceType === 'tablet';
    const isMobileDevice = deviceType === 'mobile';

    // eslint-disable-next-line no-nested-ternary
    const upgradeMessage = pricing && pricing.general.webapp_header;
    // eslint-disable-next-line no-nested-ternary
    const ugradeButtonMessage = pricing && pricing.general.webapp_header_button;
    const pricingTitle = (isTabletDevice && upgradeMessage) || null;
    const logoLonkClasses = classnames(classes.logoLink, { [classes.tabletLogoLink]: !isFullSizeDevice });
    const headerClasses = classnames(classes.header, { [classes.dailyYogaHeader]: isDailyYoga });

    return (
      <Paper elevation={5} square className={classes.wrap}>
        <header className={headerClasses}>
          {isBrowserAllowed && (
            <div className={classes.leftBox}>
              <Link
                to="/new-popular"
                className={logoLonkClasses}
                onClick={() => localStorage.setItem('menuItemColor', JSON.stringify(['item_0']))}
              >
                <img src={this.correctLogo()} alt="Muscle & Motion" />
              </Link>
              {isDailyYoga ? null : (
                <>
                  {!isMobileDevice && <span className={classes.useMsg}>{formatMessage(messages.useMsg)}</span>}
                  <button type="button" onMouseEnter={this.handleVertical} className={classes.verticalBtn}>
                    <span className={classes.verticalName}>
                      {vertical === 'strength' ? 'Strength Training' : vertical}
                    </span>
                    {openVertical ? <ExpandLess /> : <ExpandMore />}
                  </button>
                  <Tooltip title={infoMsg} placement="bottom" classes={{ tooltip: classes.noMaxWidth }}>
                    <span className={classes.infoMsg}>{mmIcons.info}</span>
                  </Tooltip>
                  <Menu
                    classes={{ paper: classes.paper, list: classes.list }}
                    anchorEl={verticalEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={openVertical}
                    onClose={this.handleCloseVertical}
                  >
                    <div onMouseLeave={this.handleCloseVertical}>
                      {lodashMap(constants.VERTICAL_ITEMS, (item, index) => {
                        if (item.label.toLowerCase() === vertical) return false;
                        if (item.label === 'Strength Training' && vertical === 'strength') return false;
                        return (
                          <MenuItem key={index} onClick={this.handleCloseVertical} classes={{ root: classes.root }}>
                            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                            <a href={item.link} target="_blank" className={classes.link} />
                            <span className={classes.verticalLabel}>{item.label}</span>
                          </MenuItem>
                        );
                      })}
                    </div>
                  </Menu>
                </>
              )}
            </div>
          )}
          {isSaleLink && (
            <div className={classes.upgradeBox}>
              <p className={classes.upgradeMsg} title={pricingTitle}>
                {upgradeMessage}
              </p>
              <SmartLink
                to={PRICING_PAGE}
                onClick={this.trackPricingPage(ugradeButtonMessage)}
                disableTrackPricingPage
                className={classes.upgradeLink}
              >
                {ugradeButtonMessage}
              </SmartLink>
            </div>
          )}
          {['/registration/dailyyoga', '/login'].indexOf(location.pathname) < 0 && isBrowserAllowed && (
            <div>
              {isOpenEasterEgg && (
                <TestTranslationMenu classes={classes} handleSelectLanguage={this.handleSelectLanguage} />
              )}
              {!userDataLoading && (
                <>
                  <button type="button" onClick={this.handleMenu} className={classes.userBtn}>
                    <AccountCircle />
                    {!isMobileDevice && (
                      <span className={classes.userName}>{formatMessage(messages.user, { name: userName })}</span>
                    )}
                  </button>
                  {sessionStorage.getItem('firebase') === 'on' && (
                    <span style={{ fontSize: 10 }}>(Firebase debug: ON)</span>
                  )}
                  {sessionStorage.getItem('mixpanel') === 'on' && (
                    <span style={{ fontSize: 10 }}>(Mixpanel debug: ON)</span>
                  )}
                  <MainMenu
                    global={global}
                    handleClose={this.handleClose}
                    handleSelectLanguage={this.handleSelectLanguage}
                    anchorEl={anchorEl}
                    menuItems={menuItems}
                    classes={classes}
                    open={open}
                    languagesFlag={languagesFlag}
                  />
                </>
              )}
            </div>
          )}
        </header>
        {userDataLoading && <AppPreloader />}
        <FavoriteFolderBtnsNoticePopup
          open={openDialog}
          handleCloseDialog={this.handleDialog}
          handleChangeLocalWebStorage={this.handleChangeLocalWebStorage}
          linkTo={linkTo}
          description={formatMessage(favoriteFolderBtnsMessages.lockPopupDescription)}
          linkToLabel={formatMessage(authRegMessages.default.startButton)}
          dontShowMsgCheckBox
        />
      </Paper>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object,
  global: PropTypes.object,
  localLanguage: PropTypes.string,
  history: PropTypes.object,
  router: PropTypes.object,
  windowSize: PropTypes.object,
  getFirebaseUpdateLanguage: PropTypes.func,
  changeLocale: PropTypes.func,
  dispatch: PropTypes.func,
  userChangeLocale: PropTypes.func,
  intl: intlShape.isRequired,
};

const HeaderIntl = injectIntl(Header);
const DeviceAdaptiveHeader = withWindowSize(HeaderIntl);
const HeaderStyled = withStyles(styles)(DeviceAdaptiveHeader);

export default connect(
  () =>
    createStructuredSelector({
      global: makeSelectGlobal(),
      localLanguage: makeSelectLocale(),
    }),
  dispatch => ({
    logoutUserAction: bindActionCreators(authActions.logoutUserAction, dispatch),
    getAZActionAction: bindActionCreators(azActions.getAZAction, dispatch),
    globalLogoutUserAction: bindActionCreators(authActions.globalLogoutUserAction, dispatch),
    userChangeLocale: bindActionCreators(AppActions.userChangeLocale, dispatch),
    getFirebaseUpdateLanguage: bindActionCreators(AppActions.getFirebaseUpdateLanguage, dispatch),
    changeLocale: bindActionCreators(languageActions.changeLocale, dispatch),
    dispatch,
  }),
)(HeaderStyled);
